import {DragDropEvent, DragManager} from "PageBuilder/pagebuilder/util/DragManager";
import {Dimension} from "PageBuilder/dto/Options";
import {StyleManager} from "./styles/StyleManager";
import {GroupProperties} from "../Properties/styles/GroupProperties";
import {PDFControlBaseOptions} from "./PDFControlBase.Options";

import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {EventManager} from "shared/utilities/Events/EventManager";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {ItemDeleted} from "PageBuilder/Events/ItemDeleted";
import {DragDropService, SectionOptionsEnum} from "InternalShared/PageBuilder/Services/DragDropService";
import {IPDFContainer} from "InternalShared/PageBuilder/Controls/Core/IPDFContainer";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {UpdateProperties} from "InternalShared/Events/UpdateProperties";
import {DuplicateFieldEvent} from "InternalShared/Events/DuplicateFieldEvent";
import {PDFControlOptionsGenerator} from "InternalShared/PageBuilder/Controls/Core/Generators/PDFControlOptionsGenerator";
import {BehaviorBase} from "PageBuilder/pagebuilder/Controls/Behaviors/BehaviorBase";
import {PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";


var basicContext=require('basiccontext');

export abstract class PDFControlBase {
    public Options: PDFControlBaseOptions;
    public $element: JQuery;
    public static SelectedElements: PDFControlBase[] = [];
    private DragDropService: DragDropService;
    public DragManager: DragManager;
    private static LatestFieldID: number = 0;
    public AllowedResizeDirection: AllowedResizeDirection = "both";
    public StyleManager: StyleManager;
    public latestDimension: Dimension;
    public ControlContainer:HTMLElement;
    public behavior:BehaviorBase;
    public get x() {
        return this.Options.Styles.Left;
    }

    public get y() {
        return this.Options.Styles.Top;
    }

    public get width() {
        return this.Options.Styles.Width;
    }

    public get height() {
        return this.Options.Styles.Height;
    }


    protected abstract InternalGenerateHtml($container: JQuery);

    public abstract GetProperties(): GroupProperties[];

    public Page: IPDFContainer;
    public GetValueEditor():PropertyBase
    {
        return null;
    }

    protected InternalGetLabel(){
        return '';
    }
    public GetLabel()
    {
        if(this.Options.TemplateFieldName=='')
            return this.InternalGetLabel();
        return this.Options.TemplateFieldName;
    }
    public SetInitialStyles() {

    }

    public PseudoInitializeWithOptions(options:PDFControlBaseOptions)
    {
        this.Options=options;
    }

    public Initialize(page: IPDFContainer, options: PDFControlBaseOptions,behavior:BehaviorBase=null) {
        if(behavior==null)
            this.behavior=new BehaviorBase();
        else
            this.behavior=behavior;
        this.behavior.SetPDFControlBase(this);
        this.DragDropService = DragDropService.Instance();
        this.Page = page;
        let isNew = false;

        if (options.Id == 0) {
            options.Id = ++PDFControlBase.LatestFieldID;
            isNew = true;
        } else {
            this.Options = options;
            PDFControlBase.LatestFieldID = Math.max(this.Options.Id, PDFControlBase.LatestFieldID);
        }

        this.$element = jQuery('<div></div>');
        switch (options.TargetId) {
            case "header":
                this.Page.$headerContainer.append(this.$element);
                break;
            case "content":
                this.Page.$contentContainer.append(this.$element);
                break;
            case "footer":
                this.Page.$footerContainer.append(this.$element);
                break;
            case "control":
                this.ControlContainer.appendChild(this.$element[0]);
                break;

        }

        this.Options = options;
        this.StyleManager = new StyleManager(this.Options.Id);
        this.InternalInitialize();
        if (isNew)
            this.SetInitialStyles();
        this.$element.css('z-index', this.Options.Styles.ZIndex);
        this.$element.attr('tabindex', 1);
        this.$element.addClass('PDFElement');
        this.$element.addClass(this.Options.Type);
        this.$element.data('element-id', this.Options.Id);
        this.GenerateHTML(this.$element);
        this.RecordDimensions();

        this.MakeItDraggable();
        this.ListenForDeleteKey();


        return this;
    }
    public InternalInitialize() {

    }

    public GetRelativeTop() {
        let section = this.Page.GetSectionContainer(this.Options.TargetId);
        return this.$element[0].getBoundingClientRect().top - section[0].getBoundingClientRect().top;
    }


    public GetRelativeRight() {

        let section = this.Page.GetSectionContainer(this.Options.TargetId);
        let rect = this.$element[0].getBoundingClientRect();
        return rect.left - section[0].getBoundingClientRect().left + rect.width;
    }

    public GetRelativeBottom() {
        let section = this.Page.GetSectionContainer(this.Options.TargetId);
        let rect = this.$element[0].getBoundingClientRect();
        return rect.top - section[0].getBoundingClientRect().top + rect.height;
    }

    public GetRelativeLeft() {
        let section = this.Page.GetSectionContainer(this.Options.TargetId);
        return this.$element[0].getBoundingClientRect().left - section[0].getBoundingClientRect().left;
    }


    public abstract GetStyles(): GroupProperties[];

    public AfterRefresh() {
        this.RecordDimensions();
    }

    public InternalAfterResize() {

    }

    public AfterResize() {
        this.InternalAfterResize();
    }


    public GetStandardFieldForPDF($content: JQuery | JQuery[] = null): JQuery {
        let $field = jQuery('<PDFField id="' + this.Options.Id + '"></PDFField>');

        if ($content != null)
            if (Array.isArray($content))
                for (let $element of $content)
                    $field.append($element);
            else
                $field.append($content as JQuery);

        return $field;

    }



    public GetPDFHTMl() {
        let $container: JQuery = jQuery(`<div data-element-id="${this.Options.Id}" id="pdfField_${this.Options.Id}" class="PDFElement ${this.Options.Type.toString()}"></div>`);
        this.GenerateHTML($container);
        return $container;
    }

    public SetBehavior(behavior:BehaviorBase){
        this.behavior=behavior;
    }

    private GenerateHTML($container: JQuery): JQuery {
        $container.css({
            'top': this.Options.Styles.Top,
            'left': this.Options.Styles.Left,
            'width': this.Options.Styles.Width,
            'height': this.Options.Styles.Height,
            position: 'absolute'
        });
        let $elementContainer = jQuery(`<div  class="elementContent"></div>`);
        $container.addClass('pdfField_' + this.Options.Id);
        $container.append($elementContainer);

        this.InternalGenerateHtml($elementContainer);

        this.behavior.OnGenerate($container[0]);
        return $elementContainer;
    }

    public MoveTo(x: string = null, y: string = null) {
        if (x == null)
            x = this.Options.Styles.Left;
        if (y == null)
            y = this.Options.Styles.Top;
        this.Options.Styles.Top = y;
        this.Options.Styles.Left = x;

        this.$element.css({top: this.Options.Styles.Top, left: this.Options.Styles.Left});
    }

    public Refresh() {
        if(this.$element==null)
            return;
        this.$element.empty();
        this.GenerateHTML(this.$element);
        this.RecordDimensions();
        this.AfterRefresh();
    }

    public RecalculateParentSectionAndPosition() {

        let sectionHolder = (this.Page).GetTargetSection(this.$element[0].getBoundingClientRect().top + document.documentElement.scrollTop, this.$element[0].getBoundingClientRect().left + document.documentElement.scrollLeft);
        if (sectionHolder == null)
            return null;


        if (sectionHolder != this.Options.TargetId) {

            let oldSection = this.Page.GetSectionContainer(this.Options.TargetId);
            let newSection = this.Page.GetSectionContainer(sectionHolder);

            this.Options.TargetId = sectionHolder;
            this.MoveTo((this.$element[0].getBoundingClientRect().left - newSection[0].getBoundingClientRect().left) + 'px', (this.$element[0].getBoundingClientRect().top - newSection[0].getBoundingClientRect().top) + 'px');
            this.$element.detach();
            newSection.append(this.$element);
            this.Refresh();
            return sectionHolder;
        }

    }


    public static ClearSelection() {
        for (let item of PDFControlBase.SelectedElements) {
            item.DeSelect();
        }

        PDFControlBase.SelectedElements = [];
    }

    public Select() {

        this.$element.addClass('ElementSelected');
        if(document.getElementById('DocumentWorkArea')!=null)
            document.getElementById('DocumentWorkArea').focus();
        if (PDFControlBase.SelectedElements.indexOf(this) < 0) {
            PDFControlBase.SelectedElements.push(this);
            this.behavior.OnSelect();
        }

    }

    public UpdateProperties(properties: PropertyBase[]) {
        EventManager.Publish(new UpdateProperties(properties));
    }

    public DeSelect() {
        if (PDFControlBase.SelectedElements.indexOf(this) > 0)
            PDFControlBase.SelectedElements.splice(PDFControlBase.SelectedElements.indexOf(this), 1);
        this.$element.removeClass('ElementSelected');
        this.behavior.OnDeSelect();

    }

    private MakeItDraggable() {
        if(!this.behavior.IsDraggable)
            return;
        this.DragManager = new DragManager(this.Page, this);
        this.DragManager.OnDragDrop = (event) => {
            this.Drop(event);
        };

    }


    private Drop(event: DragDropEvent): void {
        let dropTarget = this.DragDropService.GetDropTarget(event);
        if (dropTarget == null) {
            event.cancel = true;
        } else {
            let position = this.DragDropService.GetRelativePosition(event.pageX, event.pageY, dropTarget.$target);

            if (dropTarget.targetId != this.Options.TargetId) {
                this.$element.detach();
                dropTarget.$target.append(this.$element);
                this.Options.TargetId = dropTarget.targetId;
            }

            let newX = position.x - event.dragDeltaX;
            let newY = position.y - event.dragDeltaY;
            this.Options.Styles.Left = newX + 'px';
            this.Options.Styles.Top = newY + 'px';

            this.$element.css({
                left: newX,
                top: newY
            });

            jQuery.Velocity.hook(this.$element, 'translateX', '0px');
            jQuery.Velocity.hook(this.$element, 'translateY', '0px');
            event.cancel = true;
            event.cancelAnimation = true;

        }
        this.RecordDimensions();
        this.Select();

    }

    public abstract GetInitialOptions(): Promise<PDFControlBaseOptions>

    public async InitializeWithTarget(document: IPDFContainer, target: { targetId: SectionOptionsEnum, x: number, y: number }): Promise<boolean> {
        return new Promise<boolean>(async resolve => {
            this.Page = document;
            let options = await this.GetInitialOptions();
            if (options == null) {
                resolve(false);
                return;
            }
            if (options.Styles.Top == '')
                options.Styles.Top = target.y + 'px';
            if (options.Styles.Left == '')
                options.Styles.Left = target.x + 'px';
            options.TargetId = target.targetId;

            this.Initialize(document, options);
            resolve(true);
        });

    }

    public async InitializeWithContainer(page:IPDFContainer,container:HTMLElement,behavior:BehaviorBase,options:PDFControlBaseOptions=null): Promise<boolean> {
        return new Promise<boolean>(async resolve => {
            this.Page = page;
            if(options==null)
                options = await this.GetInitialOptions();
            if (options == null) {
                resolve(false);
                return;
            }
            options.TargetId=SectionOptionsEnum.control;
            this.ControlContainer=container;
            this.Initialize(page, options,behavior);
            resolve(true);
        });

    }


    public GetTranslatedText(): any {
        return null;
    }

    public NeedTranslations(): boolean {
        return false;
    }


    public async Remove() {

        if (await DeleteDialog.Show('this item', 'Are you sure you want to delete this item?')) {
            this.$element.remove();
            this.StyleManager.ClearFieldStyles();
            EventManager.Publish(new ItemDeleted(this));
        }


    }


    public ShowContext(e: any) {

        let items = [
            {
                title: 'Remove', icon: 'contexticon deleteItem fa fa-times', fn: () => {
                    this.Remove()
                }
            },
            {
                title: 'Duplicate', icon: 'contexticon deleteItem fa fa-files-o', fn: () => {
                    this.Duplicate()
                }
            }
        ];

        basicContext.show(items, e.originalEvent)

    }

    public Duplicate(){
        let options=this.Options.ToObject();
        let controlOptions=PDFControlOptionsGenerator.GetControlOptions(options);
        controlOptions.Id=0;



        controlOptions.Styles.Top=(this.GetRelativeTop()+20)+'px';
        controlOptions.Styles.Left=(this.GetRelativeLeft()+10)+'px';



        EventManager.Publish(new DuplicateFieldEvent(controlOptions,this.Options.Id));


    }

    private ListenForDeleteKey() {
        this.$element.keydown((event) => {
            if (event.keyCode == 46) {
                this.Remove();
            }
        });
    }

    public RecordDimensions() {
        let offset = this.$element.offset();
        this.latestDimension = {
            width: this.$element.outerWidth(),
            height: this.$element.outerHeight(),
            left: offset.left,
            top: offset.top
        };

        if (this.Options.Expandable) {
            this.Options.DesignerHeight = this.$element.outerHeight();
            this.Options.DesignerWidth=this.$element.outerWidth();
        }
    }
}
